import axios from 'axios';
import { Dispatch, FormEvent, SetStateAction, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  ErrorToast,
  SuccessToast
} from '../../../components/common/Toasts/Toasts';

import ReactCodeInput from 'react-code-input';
import Spinner from '../../../components/common/Spinner';

import { Flex } from '../../../styles/stylesStyled';

import { P2, P3 } from '../../../styles/FontStyles';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconWarning } from '../../../styles/Icons';

import {
  Button,
  Flexed,
  SecurityCodeWrapper
} from '../../../styles/GlobalComponents';
import { useAppSelector } from '../../../app/hooks';

export const Password2FA = ({
  setStep
}: {
  setStep: Dispatch<SetStateAction<number>>;
}) => {
  const { t } = useTranslation('settings');
  const [code, setCode] = useState('');
  const [code2Fa, setCode2Fa] = useState('');
  const [codeLoading, setCodeLoading] = useState(false);
  const [code2FaLoading, setCode2FaCodeLoading] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);

  const { user, token } = useAppSelector((state) => state.auth.userInfo);
  const { verificationStatus } = useAppSelector((state) => state.settings);

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token.accessToken}`
    }
  };

  const sendCode = async () => {
    try {
      setCodeLoading(true);
      await axios.post(`/user/password/change/email/code`, config);

      SuccessToast(t('email.code_sent'));
      setCodeLoading(false);
      setIsCodeSent(true);
    } catch (error: any) {
      setCodeLoading(false);
      ErrorToast(error.response.data.error);
    }
  };

  const onHandleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!code) {
      ErrorToast(t('email.enter_verification_code'));
    } else if (verificationStatus && !code2Fa) {
      ErrorToast(t('email.enter_2fa_verification_code'));
    } else {
      try {
        setCode2FaCodeLoading(true);

        await axios.put(
          `/user/password/change/confirm`,
          {
            emailCode: code,
            twoFACode: verificationStatus ? code2Fa : null
          },
          config
        );

        setCode2FaCodeLoading(false);

        setStep(3);
      } catch (error: any) {
        setCode2FaCodeLoading(false);
        ErrorToast(error.response.data.error);
      }
    }
  };
  return (
    <div>
      {codeLoading || code2FaLoading ? (
        <Spinner fullScreen={false} />
      ) : (
        <>
          <div style={{ marginBottom: 30, marginTop: 20 }}>
            <Flex>
              <Icon>
                <IconWarning color={color.colors.error500} />
              </Icon>
              <P2 light mb='30' ml='10' center>
                {t('email.text1')}
              </P2>
            </Flex>
          </div>

          <form onSubmit={onHandleSubmit}>
            <Flexed between>
              <P2 bold color={color.colors.neutral700}>
                {t('email.email_code')}
              </P2>
              <P2
                bold
                style={{ cursor: 'pointer' }}
                color={color.colors.primary900}
                onClick={() => sendCode()}>
                {t('email.send_code')}
              </P2>
            </Flexed>
            <SecurityCodeWrapper>
              <ReactCodeInput
                name='email code'
                inputMode='numeric'
                fields={7}
                value={code}
                onChange={setCode}
                type={'number'}
              />
            </SecurityCodeWrapper>
            <P3 color={color.colors.neutral500} mb='10'>
              {isCodeSent && `${t('email.enter_7_digit_code')} ${user?.email}`}
            </P3>

            {verificationStatus && (
              <div>
                <Flexed between>
                  <P2 bold color={color.colors.neutral700}>
                    {t('email.2fa_verification_code')}
                  </P2>
                </Flexed>
                <SecurityCodeWrapper is2Fa>
                  <ReactCodeInput
                    name='email code'
                    inputMode='numeric'
                    fields={6}
                    value={code2Fa}
                    onChange={setCode2Fa}
                    type={'number'}
                  />
                </SecurityCodeWrapper>
                <P3 color={color.colors.neutral500} mb='10'>
                  {t('email.enter_6_digit_code')}
                </P3>
              </div>
            )}
            <Button
              m='30px 0 10px 0'
              type='submit'
              disabled={code === '' ? true : false}>
              {t('email.confirm')}
            </Button>
          </form>
        </>
      )}
    </div>
  );
};
